// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a34ab137","455":"29242962","977":"bc54ae8f"}[chunkId] + ".chunk.js";
};